import { useCallback, useEffect, useRef, useState } from 'react'
import { randomSlug } from 'utils'
import { useWorld } from './use-world'

const positionDetail = ({ x, y, width, height, id }) => {
  const box = {
    topLeft: { x, y },
    topRight: { x: x + width, y },
    bottomLeft: { x, y: y + height },
    bottomRight: { x: x + width, y: y + height }
  }
  return { x, y, box, width, height, id }
}

export const createPosition = positionDetail

export const usePosition = (x, y, width, height, config = {}) => {
  // Stable id — never regenerated after mount
  const id = useRef(config.id || randomSlug(6)).current
  const initialPos = { x, y, width, height, id, config }

  // posRef holds the authoritative current value for use inside callbacks/effects.
  // position state drives rendering only.
  const posRef = useRef(initialPos)
  const [position, setPosition] = useState(initialPos)

  const { addSprite, removeSprite } = useWorld()

  useEffect(() => {
    addSprite(posRef.current)
    return () => removeSprite({ id })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // updatePosition is stable — addSprite is guaranteed stable from useWorld.
  // We use functional setState so we never close over stale position.
  const updatePosition = useCallback((x, y, opts = {}) => {
    const newPos = { ...posRef.current, x, y, ...opts }
    posRef.current = newPos
    addSprite(newPos)
    setPosition(newPos)
  }, [addSprite])

  return [positionDetail(position), updatePosition]
}
